export * from './appointment/types';
export * from './appointments/types';
export * from './patients/types';
export * from './specialties/types';

export const KEY = 'BOOK';

export enum State {
  Ut = 'UT'
}

export interface AddressItem {
  name: string;
  value: string | object;
}
